export const MACRO_ACTION_TYPES = [
  {
    key: 'assign_team',
    label: 'ASSIGN_TEAM',
    inputType: 'search_select',
  },
  {
    key: 'assign_agent',
    label: 'ASSIGN_AGENT',
    inputType: 'search_select',
  },
  {
    key: 'add_label',
    label: 'ADD_LABEL',
    inputType: 'multi_select',
  },
  {
    key: 'remove_label',
    label: 'REMOVE_LABEL',
    inputType: 'multi_select',
  },
  {
    key: 'remove_assigned_agent',
    label: 'REMOVE_ASSIGNED_AGENT',
    inputType: null,
  },
  {
    key: 'remove_assigned_team',
    label: 'REMOVE_ASSIGNED_TEAM',
    inputType: null,
  },
  {
    key: 'send_email_transcript',
    label: 'SEND_EMAIL_TRANSCRIPT',
    inputType: 'email',
  },
  {
    key: 'mute_conversation',
    label: 'MUTE_CONVERSATION',
    inputType: null,
  },
  {
    key: 'snooze_conversation',
    label: 'SNOOZE_CONVERSATION',
    inputType: null,
  },
  {
    key: 'resolve_conversation',
    label: 'RESOLVE_CONVERSATION',
    inputType: null,
  },
  {
    key: 'send_attachment',
    label: 'SEND_ATTACHMENT',
    inputType: 'attachment',
  },
  {
    key: 'send_message',
    label: 'SEND_MESSAGE',
    inputType: 'textarea',
  },
  {
    key: 'add_private_note',
    label: 'ADD_PRIVATE_NOTE',
    inputType: 'textarea',
  },
  {
    key: 'change_priority',
    label: 'CHANGE_PRIORITY',
    inputType: 'search_select',
  },
  {
    key: 'send_webhook_event',
    label: 'SEND_WEBHOOK_EVENT',
    inputType: 'url',
  },
  // NOOVI: acoes de Pipeline Pro. Automation Rules ja tinha as quatro; o macro
  // nao tinha nenhuma. Exibidas apenas com a feature `pipeline_board` ligada
  // (ver MacroEditor.vue), mesmo criterio do AutomationRuleForm.
  // `move_pipeline_card_to_stage` existe no servico e e aceita pela API, mas NAO
  // aparece aqui: o AutomationRuleForm tambem nao a expoe, porque escolher etapa
  // exige um seletor de funil + etapa que nenhum dos dois tem. Expor so no macro
  // quebraria a paridade macro/automation na outra direcao.
  {
    key: 'set_pipeline_card_owner',
    label: 'SET_PIPELINE_CARD_OWNER',
    inputType: 'search_select',
  },
  // `inputType: null` de proposito: no macro o valor NAO e pre-configurado no
  // editor. Quem roda o macro preenche valor/nota no modal de Ganho na hora,
  // que e o pedido do usuario — um numero fixo salvo no macro seria errado em
  // todo negocio que nao fosse aquele.
  {
    key: 'mark_pipeline_card_won',
    label: 'MARK_PIPELINE_CARD_WON',
    inputType: null,
  },
  {
    key: 'mark_pipeline_card_lost',
    label: 'MARK_PIPELINE_CARD_LOST',
    inputType: null,
  },
];

// Chaves que so aparecem com a feature `pipeline_board`. Espelha
// PIPELINE_AUTOMATION_ACTION_KEYS do automation: mesma pergunta, mesma resposta.
export const PIPELINE_MACRO_ACTION_KEYS = [
  'set_pipeline_card_owner',
  'mark_pipeline_card_won',
  'mark_pipeline_card_lost',
];

// Acoes que exigem interacao do agente ANTES de o macro concluir: o backend nao
// tem como inventar valor de venda nem motivo de perda. O executor abre o modal
// correspondente e so entao roda o macro (ver useMacroExecution).
export const MACRO_ACTIONS_REQUIRING_PROMPT = [
  'mark_pipeline_card_won',
  'mark_pipeline_card_lost',
];
